export const state = {
  insurance: null,
  insurances: []
}

export default state



// WEBPACK FOOTER //
// ./src/store/module/insurance/state.js